import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import buttonCRUDActions from '@mm/state/actions/IceBreakerButtonCRUDActions';
import {
  GenericButtonModel,
  PageButtonConfig,
} from '@mm/state/model/ButtonModel';
import { StoreState } from '@mm/state/store-interfaces';
import {
  IceBreakerKind,
  IceBreakerModel,
} from '@mm/state/model/IceBreakerModel';
import PageCRUDActions from '@mm/state/actions/PageCRUDActions';

type PageButtonModel = GenericButtonModel<PageButtonConfig>;

export const useButtonHandlers = () => {
  const dispatch: Dispatch<StoreState> = useDispatch();

  const deleteButton = (
    botId: number,
    iceBreakerId: number,
    kind: IceBreakerKind,
    button: PageButtonModel,
  ) => {
    return dispatch(
      buttonCRUDActions.delete(botId, iceBreakerId, kind, button, false, true),
    );
  };

  const updateText = (
    iceBreaker: IceBreakerModel,
    button: PageButtonModel,
    newButtonText: string,
  ) => {
    const newButton = {
      ...button,
      name: newButtonText,
    };

    return dispatch(
      buttonCRUDActions.update(
        iceBreaker.botId,
        iceBreaker.id,
        iceBreaker.kind,
        newButton,
        false,
        true,
      ),
    );
  };

  const createButton = async (
    iceBreaker: IceBreakerModel,
    button: PageButtonModel,
    withPatch: boolean = true,
  ) => {
    const newButton = await dispatch(
      buttonCRUDActions.create(
        iceBreaker.botId,
        iceBreaker.id,
        iceBreaker.kind,
        button,
        true,
        withPatch,
      ),
    );
    if (newButton) {
      await dispatch(PageCRUDActions.retrieveById(newButton.config.pageId));
    }
    return newButton;
  };

  const updateButton = (
    iceBreaker: IceBreakerModel,
    button: PageButtonModel,
  ) => {
    return dispatch(
      buttonCRUDActions.update(
        iceBreaker.botId,
        iceBreaker.id,
        iceBreaker.kind,
        button,
        false,
        true,
      ),
    );
  };

  return {
    delete: deleteButton,
    updateText,
    createButton,
    updateButton,
  };
};
